<div class="commonbanner">
  <img src="/assets/images/banner.png" alt="banner" class="img-responsive" />
  <div class="innerbanner">
    <div class="container">
      <h1>Gap Analysis</h1>
    </div>
  </div>
</div>
